import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@monksflow/monks-ui';
import { MoreVerticalIcon, Trash2Icon } from 'lucide-react';
import type { DeliveryJob } from '@/entities/media-campaign';
import { useTranslation } from 'react-i18next';

interface DeliveryJobRowActionsProps {
  job: DeliveryJob;
  onDelete: (job: DeliveryJob) => void;
}

/**
 * Row actions for a job, in the column the table already reserves for them.
 *
 * The click has to be stopped on the way out: the row itself opens the job, so without
 * it every use of this menu also navigates away from the list you were tidying.
 */
export function DeliveryJobRowActions({ job, onDelete }: DeliveryJobRowActionsProps) {
  const { t } = useTranslation('projects');
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="mini"
          aria-label={t('deliveryJobGrid.deliveryJobRowActions.actionsFor', { title: job.title })}
          className="size-9 p-0"
          onClick={(event) => event.stopPropagation()}
        >
          <MoreVerticalIcon className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(event) => event.stopPropagation()}>
        <DropdownMenuItem variant="destructive" onSelect={() => onDelete(job)}>
          <Trash2Icon className="mr-2 size-4" />
          {t('deliveryJobGrid.deliveryJobRowActions.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
